import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ccc003c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-main-container" }
const _hoisted_2 = { class: "icon-container" }
const _hoisted_3 = {
  key: 0,
  class: "count-place"
}
const _hoisted_4 = { class: "count-container" }
const _hoisted_5 = { class: "count" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "+", -1))
const _hoisted_9 = { class: "input-container" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "icon-container" }
const _hoisted_12 = {
  key: 0,
  class: "filter-container"
}
const _hoisted_13 = {
  key: 1,
  class: "result-container"
}
const _hoisted_14 = { class: "reset-button-container" }
const _hoisted_15 = {
  key: 2,
  class: "no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ResearchFilter = _resolveComponent("ResearchFilter")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_MusicalList = _resolveComponent("MusicalList")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["search-container", { 'active-filter': _ctx.isResearchResultGenerated }])
    }, [
      (_ctx.isResearchResultGenerated)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button-container",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onFilterClick()))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_font_awesome_icon, {
                class: "search-icon",
                icon: "fa-filter"
              })
            ]),
            (_ctx.filterCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (_ctx.filterCount <= 9)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.filterCount), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            _createTextVNode(" 9"),
                            _hoisted_8
                          ]))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.researchText) = $event)),
          placeholder: _ctx.$t('views.research.searchPlaceholder')
        }, null, 8, _hoisted_10), [
          [_vModelText, _ctx.researchText]
        ])
      ]),
      _createElementVNode("button", {
        class: "button-container",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearchClick()))
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_font_awesome_icon, {
            class: "search-icon",
            icon: "fa-magnifying-glass"
          })
        ])
      ])
    ], 2),
    (!_ctx.isResearchResultGenerated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_ResearchFilter, {
            "selected-fav-genres": _ctx.researchSelectedFavGenres,
            "selected-genres": _ctx.researchSelectedGenres,
            "selected-periods": _ctx.researchSelectedPeriods
          }, null, 8, ["selected-fav-genres", "selected-genres", "selected-periods"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_ctx.isFilterModalOpened)
            ? (_openBlock(), _createBlock(_component_Modal, {
                key: 0,
                data: _ctx.filterModalData,
                maxWidth: "81vw",
                maxHeight: "95vh"
              }, {
                alertHeader: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "reset-btn",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onReset()))
                    }, _toDisplayString(_ctx.$t('generic.reset')), 1)
                  ])
                ]),
                alertBody: _withCtx(() => [
                  _createVNode(_component_ResearchFilter, {
                    "selected-fav-genres": _ctx.researchSelectedFavGenres,
                    "selected-genres": _ctx.researchSelectedGenres,
                    "selected-periods": _ctx.researchSelectedPeriods
                  }, null, 8, ["selected-fav-genres", "selected-genres", "selected-periods"])
                ]),
                _: 1
              }, 8, ["data"]))
            : _createCommentVNode("", true),
          (_ctx.researchFilteredData.length)
            ? (_openBlock(), _createBlock(_component_MusicalList, {
                key: 1,
                "list-items": _ctx.researchFilteredData,
                height: "100%",
                "on-row-click": _ctx.onRowClick,
                "on-favorite": _ctx.onFavorite,
                "on-hate": _ctx.$route.name === 'ParticipantSearch' ? _ctx.onHate : undefined,
                "on-comment": _ctx.$route.name === 'ParticipantSearch' ? _ctx.onAddToSouvenir : undefined
              }, null, 8, ["list-items", "on-row-click", "on-favorite", "on-hate", "on-comment"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('generic.noData')), 1)
              ])),
          _createVNode(_component_Paginator, {
            totalItems: _ctx.researchedData,
            currentItems: _ctx.researchFilteredData,
            "get-current-page": _ctx.getCurrentSelectedPage,
            "current-page": _ctx.currentSelectedResearchPage
          }, null, 8, ["totalItems", "currentItems", "get-current-page", "current-page"])
        ]))
  ]))
}